import React, { FunctionComponent } from 'react';
import Image from 'next/image';
import * as graphCMS from '../../../domain/graphcms';

interface ImageAdapterProps {
  image: graphCMS.ImageBlock['image'],
  imageAlt: graphCMS.ImageBlock['imageAlt'],
}

const ImageAdapter: FunctionComponent<ImageAdapterProps> = ({
  image,
  imageAlt,
}) => (
  <Image
    src={image.url}
    alt={imageAlt}
    width={image.width}
    height={image.height}
  />
);

export default ImageAdapter;
